import { Calendar } from 'lucide-react';
import { useEvents } from '../../hooks/useEvents';
import { StatTile } from '../common/StatTile';
import { eventsListPath } from '../../utils/eventListLink';

interface VendorEventsTileProps {
  vendorId: string;
}

/**
 * How many events a vendor is on — booked there, or a booked line with it —
 * opening the events list filtered to them, every date and status. The count
 * is the same server query the list's Vendor filter asks (`GET /events?vendorIds=`),
 * so the number and the list it opens always agree.
 */
export function VendorEventsTile({ vendorId }: VendorEventsTileProps) {
  const { data: events, isError } = useEvents({ vendorIds: [vendorId] });
  // No answer yet, or none to be had: never a 0 that says the vendor is on nothing.
  const count = events?.length;

  return (
    <StatTile
      label="Events"
      value={count ?? '—'}
      icon={Calendar}
      color="bg-blue-500"
      subtext={isError && count === undefined ? "Couldn't load" : undefined}
      to={
        count !== undefined && count > 0
          ? eventsListPath({ vendorIds: [vendorId], range: 'all', statuses: 'all' })
          : undefined
      }
    />
  );
}
